import { Nullable } from 'cng-common/models/utils'
import settings from 'src/config/settings'

interface IRefreshTokenParameters {
  accessToken: string
  refreshToken: string
}

export const refreshToken = async ({
  accessToken,
  refreshToken,
}: IRefreshTokenParameters): Promise<Nullable<IRefreshTokenParameters>> => {
  const url = '/mbe/api/v2/access/token'

  const payload = {
    AppId: 'hpscoutso',
    AccessToken: accessToken,
    RefreshToken: refreshToken,
  }

  const response = await fetch(settings.dataServerUrl + url, {
    method: 'PUT',
    headers: {
      'Access-Control-Allow-Credentials': 'true',
      'Content-Type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json, text/plain, */*',
      Origin: window.location.origin,
    },
    body: JSON.stringify(payload),
  })

  const result = await response.json()

  if (result.AccessToken && result.RefreshToken) {
    return result
  }

  return null
}
